import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  padding: 1.25rem;
  border: 1px solid ${(props) => props.theme.colors.neutrals.gray200};
  border-radius: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    padding: 2rem;
    flex-flow: row;
    align-items: stretch;
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    padding: 0;
  }
`;

export const MessageContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 1;
    align-items: flex-start;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 2.5rem 0 2.5rem 2.5rem;
  }
`;

export const HeadlineContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("medium")} {
    text-align: left;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;

export interface LogosContainerProps {
  $background: string;
}

export const LogosContainer = Styled.div<LogosContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.375rem;
  width: 100%;
  height: 10.75rem;
  border-radius: 0.75rem;
  background: url(${(props) => props.$background}) left center / cover;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 1;
    height: auto;
    border-radius: 1rem;
    gap: 1.5rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    flex: 1;
    height: auto;
    border-radius: 0 1rem 1rem 0;
    gap: 2.875rem;
  }
`;

export const LogoWrapper = Styled.div`
  max-width: 6.25rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: 6.75rem;
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: 12.625rem;
  }
`;

export const Logo = Styled.img`
  width: 100%;
`;

export const Divider = Styled.div`
  width: 1px;
  height: 2rem;
  background-color: #FFF;
  opacity: 0.5;

  ${(props) => props.theme.breakpoints.up("medium")} {
    height: 2.125rem;
    opacity: 0.6;
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    height: 4rem;
    opacity: 0.7;
  }
`;
